module.exports = __webpack_public_path__ + "static/media/019.0a51aa4a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/products/normals/019.jpg
// module id = 492
// module chunks = 0